import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-app-contents',
  template: ` <div class="contents" [ngClass]="'top-left-no-radius'">
      <ng-content></ng-content>
    </div>
    <app-footer></app-footer>`,
  styleUrls: ['./app-contents.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, CommonModule],
})
export class AppContentsComponent {
  DIMISSED_VERIFACTU = 'dimissed_verifactu';
  DIMISSED_VERIFACTU2 = 'dimissed_verifactu_2';
  //verifactuCanBeRequested = verifactuCanBeRequested;
  @HostBinding('class') classes = 'app-contents';
  constructor() {}
}
